document.addEventListener("DOMContentLoaded", () => {

  const state = {
    nicheValue: null,
    widthValue: null,
    valid: true,
    message: null
  };

  function getReactLabelText(labelEl) {
    if (!labelEl) return null;  

    const fiberKey = Object.keys(labelEl).find(k =>
      k.startsWith('__reactFiber') || k.startsWith('__reactProps')
    );

    const fiber = fiberKey ? labelEl[fiberKey] : null;
 
    return fiber?.memoizedProps?.children
      || fiber?.pendingProps?.children
      || labelEl.innerText
      || null;
  }

  function resolveElements() {
    const wrappers = document.querySelectorAll('.po-dimension-input');

    let nicheInput = null;
    let widthInput = null;
    
    wrappers.forEach(wrapper => {
      const label = wrapper.querySelector('label');
      const text = getReactLabelText(label);    

      const input = wrapper.querySelector('input[type="number"]');
      if (!input || !text) return;

      const normalized = text.trim().toLowerCase();      

      if (normalized === 'lichtes nischenmaß') {
        nicheInput = input;
      }

      if (normalized === 'türbreite') {
        widthInput = input;
      }
    });

    return { nicheInput, widthInput };
  }

  function validate(niche, width) {
    let validValue = niche - 200;

    if (validValue < 0) {
      validValue = 0;
    }

    const valid = width <= validValue;

    return {
      valid,
      message: valid
        ? null
        : `Bitte gib einen Maximalwert von ${validValue} ein.`
    };
  }

  function renderUI(elements, result) {
    const { widthInput } = elements;

    const wrapper = widthInput.closest('.po-dimension-input');
    const errorEl = getOrCreateError(wrapper, widthInput);

    if (!result.valid) {
      errorEl.textContent = result.message || '';
      errorEl.style.display = 'block';

      widthInput.setAttribute('aria-invalid', 'true');
      widthInput.setAttribute('error', result.message);
    } else {
      errorEl.style.display = 'none';

      widthInput.removeAttribute('aria-invalid');
      widthInput.removeAttribute('error');
    }

    wrapper.classList.toggle('has-error', !result.valid);
  }

  function getOrCreateError(wrapper) {
    let el = wrapper.querySelector('.custom-max-error');

    if (!el) {
      el = document.createElement('span');

      el.className =
        'po-dimension-error po-text-left po-block po-leading-[1.2] custom-max-error';

      el.style.fontSize = '14px';
      el.style.color = 'var(--error-message-color)';
      el.style.display = 'none';

      wrapper.appendChild(el);
    }

    return el;
  }

  function runValidation() {
    const elements = resolveElements();

    const niche = parseFloat(elements.nicheInput?.value || 0);
    const width = parseFloat(elements.widthInput?.value || 0);

    const result = validate(niche, width);

    state.nicheValue = niche;
    state.widthValue = width;
    state.valid = result.valid;
    state.message = result.message;

    renderUI(elements, result);
  }

  function bindCartGuard() {
    document.addEventListener("click", (event) => {

      const btn = event.target.closest(
        'button[type="submit"], [name="add"], .product-form__submit, .add-to-cart'
      );

      if (!btn) return;

      runValidation();

      if (!state.valid) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const elements = resolveElements();
        elements.widthInput?.closest('.po-dimension-input')
          ?.scrollIntoView({ behavior: 'smooth', block: 'center' });

        elements.widthInput?.focus({ preventScroll: true });
      }

    }, true);
  }

  function init() {
    const elements = resolveElements();

    if (!elements.nicheInput || !elements.widthInput) return false;

    elements.nicheInput.addEventListener('input', runValidation);
    elements.widthInput.addEventListener('input', runValidation);

    runValidation();
    bindCartGuard();

    return true;
  }

  const observer = new MutationObserver(() => {
    if (init()) observer.disconnect();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});